<template>
  <li>
    <a class="dropdown-item" href="#">{{ text }}</a>
  </li>
</template>

<script>
export default {
  name: 'DropdownItem',
  props: {
    text: {
      type: String,
      required: true
    }
  },
}
</script>
